function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "warning (4)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41340",
  d: "M73.646 76.97H12.174A12.174 12.174 0 011.285 59.352L32.021 6.729a12.174 12.174 0 0121.777 0l30.737 52.623A12.174 12.174 0 0173.646 76.97zm0 0",
  fill: "#07a3d1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41341",
  d: "M73.654 76.97H42.91V0a12.057 12.057 0 0110.894 6.735l30.728 52.621A12.165 12.165 0 0173.654 76.97zm0 0",
  fill: "#08b39f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41342",
  d: "M48.831 63.648a5.921 5.921 0 11-5.921-5.92 5.921 5.921 0 015.921 5.92zm0 0",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41343",
  d: "M48.831 63.648a5.919 5.919 0 01-5.921 5.921V57.727a5.919 5.919 0 015.921 5.92zm0 0",
  fill: "#dee5f0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41344",
  d: "M42.91 11.841a5.921 5.921 0 015.921 5.921v28.124a5.921 5.921 0 01-11.842 0V17.762a5.921 5.921 0 015.921-5.921zm0 0",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41345",
  d: "M48.831 17.762v28.124a5.919 5.919 0 01-5.921 5.92V11.841a5.913 5.913 0 015.921 5.921zm0 0",
  fill: "#dee5f0"
}));

function SvgError(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.822,
    height: 76.97,
    viewBox: "0 0 85.822 76.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a96f4836.svg";
export { ForwardRef as ReactComponent };